<div dynamicGrid [tableContainerElement]="tableContainer" [selector]="selector" fxLayout="column" fxLayoutGap="10px">
  <div class="flex-row">
    <h2 class="flex-cell page-header">Mantenimiento De Transporte
    </h2>
  </div>
  <article class="table-header" *ngIf="canAddOrEdit">
    <button class="button1" color="primary" mat-icon-button (click)="addRow()">
      <mat-icon title='Add Row'>add_circle</mat-icon>
    </button>
    <button class="button1" color="primary" mat-icon-button (click)="save()" [disabled]="saveButtonDisabled">
      <mat-icon title='Save'>save</mat-icon>
    </button>
  </article>

  <div #tableContainer class="table-container">
    <table mat-table matSort [dataSource]="dataSource">
      <ng-container matColumnDef="codTransp">
        <th mat-header-cell class="mat-header-cell" *matHeaderCellDef mat-sort-header> Cód Transp
          <rem-string-filter #tableFilter columnDef="codTransp"
                             (filterChange)="filterChange($event);"></rem-string-filter>
        </th>
        <td class="cell-width-smtext" mat-cell *matCellDef="let element">
          <div class="cell-width-smtext" *ngIf="!element.isAdd && !element.isEdit">
            {{element.codTransp}}
          </div>
          <mat-form-field #codTranspField class="cell-width-smtext" *ngIf="element.isAdd || element.isEdit"
                          appearance="fill">
            <input autocomplete="off" matInput required minlength="1" maxlength=5 [(ngModel)]="element.codTransp"
                   (change)="checkId(element, codTranspField); checkActiveRelation(element, codTranspField);"/>
            <mat-icon matPrefix *ngIf="isDirtyAndNotAdd(element,'codTransp')"
                      color="warn" class="dirty-indicator">info
            </mat-icon>
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container matColumnDef="nombreTransp">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Nombre Transp
          <rem-string-filter #tableFilter columnDef="nombreTransp"
                             (filterChange)="filterChange($event);"></rem-string-filter>
        </th>
        <td mat-cell *matCellDef="let element" class="cell-width-med-decription">
          <div class="cell-width-med-decription breakwrap" *ngIf="!element.isAdd && !element.isEdit">
            {{element.nombreTransp}}
          </div>
          <mat-form-field class="cell-width-med-decription" *ngIf="element.isAdd || element.isEdit" appearance="fill">
            <input autocomplete="off" matInput required minlength="1" maxlength=35 [(ngModel)]="element.nombreTransp"/>
            <mat-icon matPrefix *ngIf="isDirtyAndNotAdd(element,'nombreTransp')"
                      color="warn" class="dirty-indicator">info
            </mat-icon>
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container matColumnDef="domicilio">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Domicilio
          <rem-string-filter #tableFilter columnDef="domicilio"
                             (filterChange)="filterChange($event);"></rem-string-filter>
        </th>
        <td mat-cell *matCellDef="let element" class="cell-width-med-decription">
          <div class="cell-width-med-decription breakwrap" *ngIf="!element.isAdd && !element.isEdit">
            {{element.domicilio}}
          </div>
          <mat-form-field class="cell-width-med-decription" *ngIf="element.isAdd || element.isEdit" appearance="fill">
            <input autocomplete="off" required minlength="1" matInput maxlength=45 [(ngModel)]="element.domicilio"/>
            <mat-icon matPrefix *ngIf="isDirtyAndNotAdd(element,'domicilio')"
                      color="warn" class="dirty-indicator">info
            </mat-icon>
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container matColumnDef="localidad">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Localidad
          <rem-string-filter #tableFilter columnDef="localidad"
                             (filterChange)="filterChange($event);"></rem-string-filter>
        </th>
        <td mat-cell *matCellDef="let element" class="cell-width-med-decription">
          <div class="cell-width-med-decription breakwrap" *ngIf="!element.isAdd && !element.isEdit">
            {{element.localidad}}
          </div>
          <mat-form-field class="cell-width-med-decription" *ngIf="element.isAdd || element.isEdit" appearance="fill">
            <input autocomplete="off" matInput required minlength="1" maxlength=35 [(ngModel)]="element.localidad"/>
            <mat-icon matPrefix *ngIf="isDirtyAndNotAdd(element,'localidad')"
                      color="warn" class="dirty-indicator">info
            </mat-icon>
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container matColumnDef="codProvincia">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Cód
          Provincia
          <rem-string-filter #tableFilter columnDef="codProvincia"
                             (filterChange)="filterChange($event);"></rem-string-filter>
        </th>
        <td mat-cell *matCellDef="let element" class="cell-width-mtext">
          <div class="cell-width-mtext" *ngIf="!element.isAdd && !element.isEdit">
            {{element.codProvincia}}
          </div>
          <mat-form-field class="cell-width-mtext" *ngIf="element.isAdd || element.isEdit" appearance="fill">
            <input autocomplete="off" matInput maxlength=2 required pattern="[A-Za-z]{1,2}"
                   [(ngModel)]="element.codProvincia"/>
            <mat-icon matPrefix *ngIf="isDirtyAndNotAdd(element,'codProvincia')"
                      color="warn" class="dirty-indicator">info
            </mat-icon>
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container matColumnDef="codPostal">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Cód Postal
          <rem-string-filter #tableFilter columnDef="codPostal"
                             (filterChange)="filterChange($event);"></rem-string-filter>
        </th>
        <td mat-cell *matCellDef="let element" class="cell-width-lgtext">
          <div class="cell-width-lgtext" *ngIf="!element.isAdd && !element.isEdit">
            {{element.codPostal}}
          </div>
          <mat-form-field class="cell-width-lgtext" *ngIf="element.isAdd || element.isEdit" appearance="fill">
            <input autocomplete="off" matInput maxlength=10 required pattern="[a-zA-Z0-9]{1,10}"
                   [(ngModel)]="element.codPostal"/>
            <mat-icon matPrefix *ngIf="isDirtyAndNotAdd(element,'codPostal')"
                      color="warn" class="dirty-indicator">info
            </mat-icon>
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container matColumnDef="cuit">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> CUIT
          <rem-string-filter #tableFilter columnDef="cuit"
                             (filterChange)="filterChange($event);"></rem-string-filter>
        </th>
        <td mat-cell *matCellDef="let element" class="cell-width-lgtext">
          <div class="cell-width-lgtext breakwrap" *ngIf="!element.isAdd && !element.isEdit">
            {{element.cuit}}
          </div>
          <mat-form-field class="cell-width-lgtext" *ngIf="element.isAdd || element.isEdit" appearance="fill">
            <input autocomplete="off" matInput maxlength=16 required pattern="[0-9_-]{1,30}"
                   [(ngModel)]="element.cuit"/>
            <mat-icon matPrefix *ngIf="isDirtyAndNotAdd(element,'cuit')"
                      color="warn" class="dirty-indicator">info
            </mat-icon>
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container matColumnDef="codInscripcion">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Cód<br>Inscri<br>pcion
          <rem-string-filter #tableFilter columnDef="codInscripcion"
                             (filterChange)="filterChange($event);"></rem-string-filter>
        </th>
        <td mat-cell *matCellDef="let element" class="cell-width-mtext">
          <div class="cell-width-mtext breakwrap" *ngIf="!element.isAdd && !element.isEdit">
            {{element.codInscripcion}}
          </div>
          <mat-form-field *ngIf="element.isAdd || element.isEdit" appearance="fill" class="cell-width-mtext">
            <input autocomplete="off" matInput maxlength=30 required pattern="[A-Za-z]{1,30}"
                   [(ngModel)]="element.codInscripcion"/>
            <mat-icon matPrefix *ngIf="isDirtyAndNotAdd(element,'codInscripcion')"
                      color="warn" class="dirty-indicator">info
            </mat-icon>
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container matColumnDef="estado">
        <th mat-header-cell *matHeaderCellDef scope="col" mat-sort-header> Estado
        </th>
        <td mat-cell *matCellDef="let element" class="cell-width-mtext">
          <div *ngIf="!element.isEdit; else statusBox">
            <span *ngIf="element.estado">Active</span>
            <span *ngIf="!element.estado">Inactive</span>
          </div>
          <ng-template #statusBox>
            <mat-form-field #estadoField appearance="fill" class="cell-width-mtext">
              <mat-select [(ngModel)]="element.estado" (selectionChange)="checkActiveRelation(element, estadoField)" name="estado">
                <mat-option [value]=true>
                  Active
                </mat-option>
                <mat-option [value]=false>
                  Inactive
                </mat-option>
              </mat-select>
              <mat-icon matPrefix *ngIf="isDirtyAndNotAdd(element,'estado')"
                        color="warn" class="dirty-indicator">info
              </mat-icon>
            </mat-form-field>
          </ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="fecCreacion">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Fec Creación
          <rem-date-filter #tableFilter columnDef="fecCreacion" [operators]="dateOperators"
                           (filterChange)="filterChange($event);"></rem-date-filter>
        </th>
        <td mat-cell *matCellDef="let element" class="cell-width-mtext">
          <div>
            {{element.fecCreacion  | date:'dd/MM/yyyy'}}
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="usrCreacion">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Usu Creación
          <rem-string-filter #tableFilter columnDef="usrCreacion" [operators]="operators"
                             (filterChange)="filterChange($event);"></rem-string-filter>
        </th>
        <td mat-cell *matCellDef="let element" class="cell-width-mtext">
          <div>
            {{element.usrCreacion}}
          </div>
        </td>
      </ng-container>


      <ng-container matColumnDef="fecModif">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Fec Modificación
          <rem-date-filter #tableFilter columnDef="fecModif" [operators]="dateOperators"
                           (filterChange)="filterChange($event);"></rem-date-filter>
        </th>
        <td mat-cell *matCellDef="let element" class="cell-width-mtext">
          <div>
            {{element.fecModif  | customDate}}
          </div>
        </td>
      </ng-container>


      <ng-container matColumnDef="usrModif">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Usu modificación
          <rem-string-filter #tableFilter columnDef="usrModif" [operators]="operators"
                             (filterChange)="filterChange($event);"></rem-string-filter>
        </th>
        <td mat-cell *matCellDef="let element" class="cell-width-mtext">
          <div>
            {{element.usrModif}}
          </div>
        </td>
      </ng-container>


      <ng-container matColumnDef="isEdit">
        <th mat-header-cell *matHeaderCellDef>
        </th>
        <td mat-cell *matCellDef="let element">
          <div class="btn-edit" *ngIf="canAddOrEdit">
            <div *ngIf="!element.isEdit && !element.isAdd">
              <button class="button1" color="secondary" mat-icon-button (click)="editRow(element)">
                <mat-icon title='Edit'>create</mat-icon>
              </button>
            </div>
          </div>
          <div class="btn-edit" *ngIf="canAddOrEdit">
            <div *ngIf="element.isEdit || element.isAdd">
              <button class="button1" color="tertiary" mat-icon-button (click)="cancelRow(element)">
                <mat-icon title='Edit'>cancel</mat-icon>
              </button>
            </div>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: columnsToDisplay;"></tr>

    </table>

  </div>
  <mat-paginator [length]="resultsLength" [pageSize]="pageSize" [pageSizeOptions]="[10, 15, 20, 25]"></mat-paginator>
</div>
